import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Navbar,
  Nav,
} from 'reactstrap';

import getPermissions from '../permissions';
import PdxNavPanel from '../PdxNavPanel';
import PdxNavItem from '../PdxNavItem';
import PdxNavPanelSection from '../PdxNavPanel/PdxNavPanelSection';
import PdxNavPanelSectionHeader from '../PdxNavPanel/PdxNavPanelSectionHeader';
import PdxNavPanelSectionItem from '../PdxNavPanel/PdxNavPanelSectionItem';
import RightNav from '../RightNav';
import PdxNavLink from '../PdxNavLink';
import WhatsNewPanel from '../WhatsNewPanel';
import sections from './sections';
import Logo from '../../Logo';
import { LINK_IDS } from '../nav-links';

import '../NavbarVariant.css';
import '../MagicLine.css';

export const JobsToBeDoneNavbarComponent = ({ permissions }) => (
  <div className="navbar-variant">
    <Navbar expand="md">
      <Logo />
      <Nav className="mr-auto ml-0" navbar>
        {!permissions.currentUserReadOnlyLimited && (
          <React.Fragment>
            <PdxNavItem id={LINK_IDS.INCIDENTS}>
              <PdxNavLink id={LINK_IDS.INCIDENTS} sectionItems={sections.Incidents} />
              <PdxNavPanel cols={2}>
                <PdxNavPanelSection>
                  <PdxNavPanelSectionHeader>Response</PdxNavPanelSectionHeader>
                  <PdxNavPanelSectionItem id={LINK_IDS.ALL_INCIDENTS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.ALERTS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.RECENT_CHANGES} badge="beta" />
                  <PdxNavPanelSectionItem id={LINK_IDS.VISIBILITY} />
                  <PdxNavPanelSectionItem id={LINK_IDS.POSTMORTEMS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.POSTMORTEMS_PREVIEW} />
                </PdxNavPanelSection>
                <PdxNavPanelSection>
                  <PdxNavPanelSectionHeader>Settings</PdxNavPanelSectionHeader>
                  <PdxNavPanelSectionItem id={LINK_IDS.RESPONSE_PLAYS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.CONFERENCE_BRIDGES} />
                </PdxNavPanelSection>
              </PdxNavPanel>
            </PdxNavItem>
            <PdxNavItem id={LINK_IDS.SERVICES}>
              <PdxNavLink id={LINK_IDS.SERVICES} sectionItems={sections.Services} />
              <PdxNavPanel>
                <PdxNavPanelSection>
                  <PdxNavPanelSectionItem id={LINK_IDS.SERVICE_DIRECTORY} />
                  <PdxNavPanelSectionItem id={LINK_IDS.BUSINESS_SERVICES} />
                  <PdxNavPanelSectionItem id={LINK_IDS.IMPACT_METRICS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.EVENT_RULES} />
                  <PdxNavPanelSectionItem id={LINK_IDS.EVENT_INTELLIGENCE} />
                </PdxNavPanelSection>
              </PdxNavPanel>
            </PdxNavItem>
            <PdxNavItem id={LINK_IDS.PEOPLE}>
              <PdxNavLink id={LINK_IDS.PEOPLE} sectionItems={sections.People} />
              <PdxNavPanel split cols={3}>
                <PdxNavPanelSection split>
                  <PdxNavPanelSectionHeader>Schedule</PdxNavPanelSectionHeader>
                  <PdxNavPanelSectionItem id={LINK_IDS.MY_ON_CALL_SHIFTS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.SCHEDULES} />
                  <PdxNavPanelSectionItem id={LINK_IDS.ESCALATION_POLICIES} />
                </PdxNavPanelSection>
                <PdxNavPanelSection split>
                  <PdxNavPanelSectionHeader>Directory</PdxNavPanelSectionHeader>
                  <PdxNavPanelSectionItem id={LINK_IDS.USERS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.TEAMS} />
                </PdxNavPanelSection>
                <WhatsNewPanel />
              </PdxNavPanel>
            </PdxNavItem>
            <PdxNavItem id={LINK_IDS.ANALYTICS}>
              <PdxNavLink id={LINK_IDS.ANALYTICS} sectionItems={sections.Analytics} />
              <PdxNavPanel>
                <PdxNavPanelSection>
                  <PdxNavPanelSectionItem id={LINK_IDS.REPORTS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.REPORTS_PREVIEW} />
                  <PdxNavPanelSectionItem id={LINK_IDS.INTELLIGENT_DASHBOARDS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.OPERATIONAL_REVIEWS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.OPERATIONS_HEALTH} />
                  <PdxNavPanelSectionItem id={LINK_IDS.ON_CALL_READINESS} />
                  <PdxNavPanelSectionItem id={LINK_IDS.PD_LABS} badge="beta" />
                </PdxNavPanelSection>
              </PdxNavPanel>
            </PdxNavItem>
            <PdxNavItem id={LINK_IDS.STATUS_DASHBOARD}>
              <PdxNavLink id={LINK_IDS.STATUS_DASHBOARD} sectionItems={sections.Status} />
            </PdxNavItem>
            <PdxNavItem id={LINK_IDS.NEW_STATUS_DASHBOARD}>
              <PdxNavLink id={LINK_IDS.NEW_STATUS_DASHBOARD} sectionItems={sections.Status} />
            </PdxNavItem>
          </React.Fragment>
        )}
        <span className="magicLine jobsToBeDoneNavbar" />
      </Nav>
      <RightNav />
    </Navbar>
  </div>
);

JobsToBeDoneNavbarComponent.propTypes = {
  permissions: PropTypes.objectOf(PropTypes.bool).isRequired
};

const mapStateToProps = state => ({
  permissions: getPermissions(state),
});

export default connect(mapStateToProps)(JobsToBeDoneNavbarComponent);
